import { RouterProvider } from '@tanstack/react-router';

import { AppProviders } from '@/providers/app-providers';
import { router } from '@/singletons';

import './index.css';

/**
 * Provides the main application providers and router
 * Wrapped with Sentry profiler for performance monitoring
 */
export const Root = () => {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
};
